import { GatePass } from './../../../_models/gate_pass';
import { Guardian } from 'src/app/_models/guardian';
import { GuardianService } from './../../../_services/guardian.service';
import { AuthService } from './../../../_services/auth.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-guardian-tools-and-services',
  templateUrl: './guardian-tools-and-services.component.html',
  styleUrls: ['./guardian-tools-and-services.component.css']
})
export class GuardianToolsAndServicesComponent implements OnInit {
  @Input() gatePass:GatePass =undefined
  guardian:Guardian = undefined
  serverGuardianId=0
  constructor(
    public authService:AuthService,
    private guardianService:GuardianService
  ) {

    this.guardianService.guardianSubject.subscribe(
      x=>{
        this.guardian=x
        this.serverGuardianId=this.guardian.server_guardian_id
      }
    )

   }



  ngOnInit(): void {

  }

}
